import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss']
})
export class HeaderBarComponent implements OnInit {
  private _menuOpened: boolean = false;

  constructor(
    private navigationService: NavigationService,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    this.navigationService.opened.subscribe({
      next: res => {
        this._menuOpened = res;
      }
    });
  }

  public get userName() {
    return this.navigationService.userName ?? '';
  }

  public get menuOpened() {
    return this._menuOpened;
  }

  public set menuOpened(value: boolean) {
    this.navigationService.setOpen(value);
  }

  public get language() {
    return this.languageService;
  }
}
